export const REDUCER_NAME = 'authors';
